import ReactMarkdown from 'react-markdown';
import { Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar } from 'components';
import { NetbankForm } from './NetbankForm';
import { useNetbank } from './useNetbank';

export function Netbank() {
	const p = useNetbank();
	return (
		<ProgressBar page="netbank">
			<Typography TagName="h3" className="mb-5">
				{p.t('title', 'netbank')}
			</Typography>
			<ReactMarkdown>{p.t('main', 'netbank')}</ReactMarkdown>
			<hr className="my-4" />
			<NetbankForm {...p} />
			<Footer
				handleNext={p.submitForm}
				handlePrev={p.goBack}
				isDisabled={false}
				next={p.t('continue')}
				prev={p.t('back')}
			/>
		</ProgressBar>
	);
}
